import React, { useEffect, useState } from "react";
import config from "../../config";
import axios from "axios";
import LoginChecked from "../Shared/LoginChecked";
import BoxCard from "../Shared/BoxCard";
import {
  Row,
  Col,
  Modal,
  Table,
  Form,
  Popconfirm,
  Pagination,
  Input,
  Select,
  DatePicker,
  Dropdown,
  Space,
  Button,
  message,
  Tooltip,
  Skeleton,
  Checkbox,
  Alert,
} from "antd";
import moment from "moment";
import {
  PrinterOutlined,
  EditOutlined,
  DownOutlined,
  IdcardOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import AccountDropDown from "../Shared/AccountDropDown";
import { NavLink, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { ArrowDown, ArrowUp, Money, Users } from "../UserControls/Icons";
import { NumberFormat } from "../Shared/Utility";
import { SparklesIcon } from "@heroicons/react/24/outline";

function ManageVouchers() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [searchParams] = useSearchParams();
  const bypassEditDaysCheck = searchParams.get("posting_fix") === "1";
  const postingFixVoucherId = searchParams.get("voucher_id");
  const [Data, setData] = useState("");
  const [StartDate, SetStartDate] = useState(
    dayjs().subtract(30, "day").format("YYYY-MM-DD")
  );
  const [EndDate, SetEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [OrderBy, SetOrderBy] = useState("1");
  const [AccountID, SetAccountID] = useState(0);

  const { RangePicker } = DatePicker;
  const [ModalType, setModalType] = useState("");
  const VoucherMode = "General";

  const [voucherNo, setVoucherNo] = useState(0);
  const [VoucherId, setVoucherId] = useState("");
  const [debitAccountID, setdebitAccountID] = useState(0);
  const [form] = Form.useForm();

  const [total, setTotal] = useState(0);
  const [VoucherType, SetVoucherType] = useState("");
  const [DebitAccountID, SetDebitAccountID] = useState(0);

  const [listofVouchers, SetlistofVouchers] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [IsVoucherUpdated, setIsVoucherUpdated] = useState(false);
  const [Button_Lodding, setButton_Lodding] = useState(false);
  const accounts = AccountDropDown();
  const [CreditAccountLoading, setCreditAccountLoading] = useState(false);
  const [debitAccountLoading, setDebitAccountLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [selectedVoucher, setSelectedVoucher] = useState(null);

  const [creditAccountID, setcreditAccountID] = useState(0);
  const [CreditAccountID, setCreditAccountID] = useState(0);

  const [Voucherloading, setVoucherloading] = useState(false);

  const [isDeleted, setIsDeleted] = useState(false);
  const [DebitAcountBalance, setDebitAcountBalance] = useState({});
  const [CreditAcountBalance, setCreditAcountBalance] = useState({});

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [autoDiscription, setAutoDiscription] = useState("");

  const [paymentChecked, setPaymentChecked] = useState(false);
  const [keepOpenForNextEntry, setKeepOpenForNextEntry] = useState(false);

  const fetchNextVoucherNo = () => {
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      VoucherMode: VoucherMode,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "/Voucher/GetNextVoucherNo",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setVoucherNo(response.data.NextVoucherNo);
        }
      })
      .catch(function (error) { });
  };

  useEffect(() => {
    fetchNextVoucherNo();
  }, [Voucherloading]);

  useEffect(() => {
    document.title = "Manage Vouchers";
    setIsDeleted(false);
    setIsVoucherUpdated(false);
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
      OrderBy: OrderBy,
      PageNo: pageNo,
      PageSize: pageSize,
      AccountID: AccountID,
      VoucherType: VoucherType,
      VoucherMode: VoucherMode,
      Debit_Account_ID: DebitAccountID,
      Credit_Account_ID: creditAccountID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Voucher/GetVouchersWithType",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          // Handle success
          SetlistofVouchers(response.data.listofVouchers);
          setTotal(response.data);
          setTotalRecords(response.data.totalRecords);
          setData(response.data);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) { });
  }, [
    DebitAccountID,
    creditAccountID,
    AccountID,
    OrderBy,
    VoucherType,
    IsVoucherUpdated,
    StartDate,
    EndDate,
    pageSize,
    pageNo,
    isDeleted,
  ]);

  /** Open a specific voucher for edit when arriving from posting-integrity. */
  useEffect(() => {
    if (!postingFixVoucherId || !UserID || !AccessKey) return;
    const id = parseInt(postingFixVoucherId, 10);
    if (!id) return;

    axios({
      method: "post",
      url: config.base_url + "Voucher/GetVoucherByID",
      headers: { "Content-Type": "application/json" },
      data: { UserID, AccessKey, ID: id },
    })
      .then((response) => {
        if (response.data.status_code !== 1) {
          message.error(
            response.data.status_message || "Could not open voucher from diagnostics."
          );
          return;
        }
        const record = response.data;
        const debitId =
          record.DebitAccount?.ID ??
          record.Debit_Account_ID ??
          record.Debit_Account?.ID;
        const creditId =
          record.CreditAccount?.ID ??
          record.Credit_Account_ID ??
          record.Credit_Account?.ID;
        setModalType("Edit");
        setVoucherNo(record.VoucherNo);
        setVoucherId(record.ID);
        if (debitId) {
          setdebitAccountID(debitId);
          onSelectDebitAccount(debitId);
        }
        if (creditId) {
          setcreditAccountID(creditId);
          setCreditAccountID(creditId);
          onSelectCreditAccount(creditId);
        }
        form.setFieldsValue({
          voucherNo: record.VoucherNo,
          Amount: record.Amount,
          Dated: dayjs(record.Dated),
          Debit_Account_ID: debitId,
          Credit_Account_ID: creditId,
          Description: record.Description,
          PaymentReference: record.PaymentReference,
        });
        setOpen(true);
      })
      .catch(() => {
        message.error("Could not open voucher from diagnostics.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingFixVoucherId]);

  const handleTableChange = async (pagination, filters, sorter) => {
    // Make API request with sorting parameters
    const sortField = sorter.field;
    const sortOrder = sorter.order === "descend" ? "desc" : "asc";

    if (sortField == "Dated") {
      if (sortOrder == "asc") {
        SetOrderBy(6);
      } else {
        SetOrderBy(5);
      }
    } else if (sortField == "VoucherNo") {
      if (sortOrder == "asc") {
        SetOrderBy(2);
      } else {
        SetOrderBy(1);
      }
    }
  };

  const handelDelete = (ID) => {
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: ID,
    };
    const api_config = {
      method: "post",
      url: config.base_url + "Voucher/DeleteVoucher",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          setIsDeleted(true);
          setLoading(false);
          message.success(response.data.status_message);
        } else {
          setLoading(false);
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "SR",
      render: (_, record, index) => index + 1 + pageSize * (pageNo - 1),
      key: "Sr",
    },
    {
      title: "Dated",
      dataIndex: "Dated",
      key: "dated",
      render: (_, record) => moment(record.Dated).format(config.date_format),
      sorter: true,
    },
    {
      title: "No",
      dataIndex: "VoucherNo",
      key: "VoucherNo",
      sorter: true,
    },
    {
      title: "Debit Account",
      dataIndex: "Debit_Account",
      key: "Debit_Account",
      render: (_, record) => {
        return record.Debit_Account ? (
          <a
            target="_blank"
            href={`/accounts/account-ledger/?account_id=${record.Debit_Account_ID}`}
          >
            {record.Debit_Account.Name}
          </a>
        ) : (
          ""
        );
      },
    },

    {
      title: "Credit Account",
      dataIndex: "Credit_Account",
      key: "Credit_Account",
      render: (_, record) => {
        return record.Credit_Account ? (
          <a
            target="_blank"
            href={`/accounts/account-ledger/?account_id=${record.Credit_Account_ID}`}
          >
            {record.Credit_Account.Name}
          </a>
        ) : (
          ""
        );
      },
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "description",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      sorter: true,
      align: "right",
      render: (_, record) => {
        return NumberFormat(record.Amount, 0);
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a type="button" onClick={() => handelShowModal("Edit", record)}>
            <Tooltip title="Edit Voucher">
              <EditOutlined />
            </Tooltip>
          </a>
          <Popconfirm
            title="Sure to delete?"
            discription="Are You sure to delete this data"
            onConfirm={(e) => handelDelete(record.ID)}
          >
            <Tooltip title="Delete Voucher">
              <DeleteOutlined />
            </Tooltip>
          </Popconfirm>
          <NavLink
            to={`/accounts/print-voucher-list/?voucher_id=${record.ID}`}
            target="_blank"
          >
            <Tooltip title="Print Voucher">
              <PrinterOutlined />
            </Tooltip>
          </NavLink>
        </Space>
      ),
    },
  ];

  const onPageChange = (page) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1); // Reset to the first page when changing page size
    setPageSize(size);
  };

  const handleAccountChange = (value) => {
    SetAccountID(value);
  };

  const onSelectDebitAccount = (item) => {
    setdebitAccountID(item);
    setDebitAccountLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: item,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccountbyIDWithBalance",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setDebitAcountBalance(response.data);
          setDebitAccountLoading(false);
        } else {
          // Handle error
          setDebitAccountLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onSelectCreditAccount = (item) => {
    setCreditAccountID(item);
    setCreditAccountLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: item,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "account/GetAccountbyIDWithBalance",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setCreditAcountBalance(response.data);
          setCreditAccountLoading(false);
        } else {
          // Handle error
          // setloadingCustomerAccount(false);
        }
        setCreditAccountLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleDateChange = (date, value) => {
    SetStartDate(value[0]);
    SetEndDate(value[1]);
  };
  const disableDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handelShowModal = (type, record) => {
    setModalType(type);

    if (type == "Edit") {
      onSelectCreditAccount(record.Credit_Account_ID);
      onSelectDebitAccount(record.Debit_Account_ID);
      const data = {
        voucherNo: record.VoucherNo,
        Amount: record.Amount,
        Dated: dayjs(record.Dated),
        Debit_Account_ID: record.Debit_Account?.ID,
        Credit_Account_ID: record.Credit_Account?.ID,
        Description: record.Description,
      };
      form.setFieldsValue(data);
      setVoucherNo(record.VoucherNo);
      setVoucherId(record.ID);
    } else {
      setVoucherloading(false);
    }
    setOpen(true);
  };

  const handleCancel = () => {
    setSelectedVoucher(null);
    setOpen(false);
    setButton_Lodding(false);
    setKeepOpenForNextEntry(false);

    setVoucherloading(true);
    form.resetFields();
    setVoucherId("");

    setCreditAccountID(0);
    setdebitAccountID(0);

    setDebitAcountBalance({ Balance: 0, BalanceType: "" });
    setCreditAcountBalance({ Balance: 0, BalanceType: "" });
  };

  const handelVoucher = (formData) => {
    setIsVoucherUpdated(true);
    setButton_Lodding(true);
    setLoading(true);

    formData["Dated"] = dayjs(formData["Dated"]).format("YYYY-MM-DD");

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      VoucherMode: VoucherMode,
      Credit_Account_ID: creditAccountID,
      Debit_Account_ID: debitAccountID,
      ...formData,
      BypassEditDaysCheck: bypassEditDaysCheck,
    };

    if (ModalType === "Edit") {
      data.ID = VoucherId;
    }

    const api_config = {
      method: "post",
      url:
        config.base_url +
        (ModalType === "Edit"
          ? "Voucher/UpdateVoucher"
          : "Voucher/AddNewVoucher"),
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          if (ModalType === "Add") {
            if (keepOpenForNextEntry) {
              const debitId = form.getFieldValue("Debit_Account_ID");
              const creditId = form.getFieldValue("Credit_Account_ID");
              const currentDate = form.getFieldValue("Dated");
              form.setFieldsValue({
                Amount: undefined,
                Description: "",
                PaymentReference: "",
                CheckReference: false,
                Dated: currentDate || dayjs(),
                Debit_Account_ID: debitId,
                Credit_Account_ID: creditId,
              });
              if (debitId) {
                setdebitAccountID(debitId);
                onSelectDebitAccount(debitId);
              }
              if (creditId) {
                setCreditAccountID(creditId);
                setcreditAccountID(creditId);
                onSelectCreditAccount(creditId);
              }
              fetchNextVoucherNo();
              setVoucherloading(true);
            } else {
              handleCancel();
            }
          }
          if (ModalType === "Edit") {
            setOpen(false);
            setCreditAcountBalance({ Balance: 0, BalanceType: "" });
          }

          setConfirmLoading(false);

          if (!(ModalType === "Add" && keepOpenForNextEntry)) {
            setVoucherloading(true);
          }

          setIsVoucherUpdated(false);
          setButton_Lodding(false);
          setLoading(false);

          message.success(response.data.status_message);
        } else {
          setLoading(false);
          setButton_Lodding(false);
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        setLoading(false);
        setButton_Lodding(false);
        message.error("Network Error");
        console.log(error);
      });
  };

  const handleCheckboxChange = () => {
    setPaymentChecked((prev) => !prev);
    console.log(paymentChecked);
  };

  return (
    <>
      <LoginChecked />

      <Modal
        title={
          ModalType == "Edit" ? "Update General Voucher" : "Add General Voucher"
        }
        open={open}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={handelVoucher}
          autoComplete="off"
          form={form}
        >
          <Row gutter={[16, 3]}>
            <Col span={8} xs={12} md={8}>
              <Form.Item label={`Voucher No`} rules={[{ required: true }]}>
                <Input disabled value={voucherNo} />
              </Form.Item>
            </Col>
            <Col span={8} xs={12} md={8}>
              <Form.Item
                name="Amount"
                label="Amount"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} xs={24} md={8}>
              <Form.Item name="Dated" label="Date" rules={[{ required: true }]}>
                <DatePicker style={{ width: "100%" }} allowClear />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} md={12}>
              <Form.Item
                label="Debit Account"
                name="Debit_Account_ID"
                className="input-vertical"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select Account"
                  optionFilterProp="children"
                  onChange={onSelectDebitAccount}
                  loading={debitAccountLoading}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={accounts}
                />
              </Form.Item>
              {debitAccountLoading ? (
                <>
                  <p>
                    <Skeleton.Input style={{ width: 150, height: 40 }} active />
                  </p>
                </>
              ) : (
                <>
                  <p style={{ textAlign: "Left", marginTop: 0 }}>
                    <span className="lbl">Current Balance </span>
                    <span className="val balance">
                      Rs.{" "}
                      <strong>
                        {NumberFormat(DebitAcountBalance.Balance, 0)}
                      </strong>{" "}
                      {DebitAcountBalance.BalanceType}
                    </span>
                  </p>
                </>
              )}
            </Col>

            <Col span={12} xs={24} md={12}>
              <Form.Item
                label="Credit Account"
                name="Credit_Account_ID"
                className="input-vertical"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select Account"
                  optionFilterProp="children"
                  onChange={onSelectCreditAccount}
                  loading={CreditAccountLoading}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={accounts}
                />
              </Form.Item>
              {CreditAccountLoading ? (
                <>
                  <p>
                    <Skeleton.Input style={{ width: 150, height: 40 }} active />
                  </p>
                </>
              ) : (
                <>
                  <p style={{ textAlign: "Left", marginTop: 0 }}>
                    <span className="lbl">Current Balance </span>
                    <span className="val balance">
                      Rs.{" "}
                      <strong>
                        {NumberFormat(CreditAcountBalance.Balance, 0)}
                      </strong>{" "}
                      {CreditAcountBalance.BalanceType}
                    </span>
                  </p>
                </>
              )}
            </Col>
            <Col span={12} xs={24} md={24} style={{ position: 'relative' }}>
              <Button
                shape="circle"
                type="text"
                style={{ position: "absolute", top: "-8px", right: "0", zIndex:"1" }}
                disabled={!form.getFieldValue("Amount") || !form.getFieldValue("Debit_Account_ID") || !form.getFieldValue("Credit_Account_ID") || !form.getFieldValue("Dated")}
                onClick={() => {
                  const amount = form.getFieldValue("Amount") || 0;
                  const currentDate = dayjs(form.getFieldValue("Dated")).format("YYYY-MM-DD");
                  const debitAccount = accounts.find((acc) => acc.value === form.getFieldValue("Debit_Account_ID"))?.label || "Debit Account";
                  const creditAccount = accounts.find((acc) => acc.value === form.getFieldValue("Credit_Account_ID"))?.label || "Credit Account";
                  const autoDescription = `Payment of Rs. ${amount} recorded, debited from ${debitAccount} account and credited to ${creditAccount} on ${dayjs(currentDate).format("DD MMM YYYY")}.`;
                  form.setFieldsValue({ Description: autoDescription });
                }}
              >
                <Tooltip title="Genrate with AI">
                                  <SparklesIcon width={20} color="#4e3efa" />
                                </Tooltip>
              </Button>
              <Form.Item name="Description" label="Description">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} md={12}>
              <Form.Item
                name="PaymentReference"
                label="Enter Payment Reference"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} md={12} style={{ marginTop: "auto" }}>
              <Form.Item name="CheckReference" valuePropName="checked">
                <Checkbox>Check Payment Reference</Checkbox>
              </Form.Item>
            </Col>

            {ModalType === "Add" && (
              <Col span={24}>
                <Checkbox
                  checked={keepOpenForNextEntry}
                  onChange={(e) => setKeepOpenForNextEntry(e.target.checked)}
                >
                  After save, keep this window open and keep the same debit and
                  credit accounts selected (for entering another voucher)
                </Checkbox>
              </Col>
            )}

            <Col span={24}>
              <div className="text-right">
                <Space wrap>
                  <Button
                    type="primary"
                    size="large"
                    shape="round"
                    loading={Button_Lodding}
                    htmlType="submit"
                  >
                    {ModalType == "Edit"
                      ? "Update General Voucher"
                      : "Add General Voucher"}
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">General Vouchers</h3>
            <div className="header-actions">
              <NavLink
                to={`/vouchers/print-voucher-details/?StartDate=${StartDate}&EndDate=${EndDate}&AccountID=${AccountID}&VoucherMode=${VoucherMode}&VoucherType=${VoucherType}&Debit_Account_ID=${DebitAccountID}&Credit_Account_ID=${creditAccountID}`}
                target="blank"
              >
                <Button
                  type="dashed"
                  shape="round"
                  size="large"
                  icon={<PrinterOutlined />}
                >
                  Download / Print
                </Button>
              </NavLink>
              <Button
                type="primary"
                size="large"
                shape="round"
                icon={<PlusOutlined />}
                onClick={() => handelShowModal("Add", {})}
              >
                Add Voucher
              </Button>
            </div>
          </div>

          {bypassEditDaysCheck ? (
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              message="Opened from posting diagnostics"
              description={
                postingFixVoucherId
                  ? `Voucher #${postingFixVoucherId} is ready to edit. The usual edit day-limit will be bypassed when you save.`
                  : "The usual edit day-limit will be bypassed when you save a voucher from this session."
              }
            />
          ) : null}

          <div className="card-total-detal">
            <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Total Vouchers"
                  amount={Data.TotalVouchers}
                  icon={<Users />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Debits Count"
                  amount={Data.DebitCount}
                  icon={<ArrowDown />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Credits Count"
                  amount={Data.CreditCount}
                  icon={<ArrowUp />}
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Total Amount"
                  prefix="Rs."
                  amount={Data.Total}
                  icon={<Money />}
                />
              </Col>
            </Row>
          </div>

          <div className="filters-wrap">
            <Form>
              <Form.Item name="">
                <RangePicker
                  style={{
                    width: "100%",
                    marginLeft: 5,
                  }}
                  onChange={handleDateChange}
                  disabledDate={disableDate}
                />
              </Form.Item>

              <Form.Item name="">
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "160px",
                  }}
                  placeholder="Account"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  loading={accounts ? false : true}
                  options={accounts}
                  onChange={handleAccountChange}
                />
              </Form.Item>

              <Form.Item name="VoucherType">
                <Select
                  allowClear
                  style={{
                    width: "160px",
                  }}
                  placeholder="Voucher Type"
                  onChange={(value) => SetVoucherType(value)}
                  options={[
                    {
                      value: "Received Amount",
                      label: "Received Amount",
                    },
                    {
                      value: "Paid Amount",
                      label: "Paid Amount",
                    },
                    {
                      value: "Expenses",
                      label: "Expenses",
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item name="Debit_Account">
                <Select
                  allowClear
                  showSearch
                  style={
                    {
                      // width: '80%',
                    }
                  }
                  placeholder="Debit Account"
                  onChange={(value) => SetDebitAccountID(value)}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  loading={accounts ? false : true}
                  options={accounts}
                />
              </Form.Item>

              <Form.Item name="Credit_Account">
                <Select
                  showSearch
                  allowClear
                  style={
                    {
                      // width: '80%',
                    }
                  }
                  placeholder="Credit Account"
                  onChange={(value) => setcreditAccountID(value)}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  loading={accounts ? false : true}
                  options={accounts}
                />
              </Form.Item>
            </Form>
          </div>

          {/* --------------------------------------------Table---------------------------------------- */}
          <br />

          <Table
            size="small"
            columns={columns}
            dataSource={listofVouchers}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
            bordered
            scroll={{
              x: "100%",
            }}
            summary={(pageData) => {
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={6} align="right">
                    <b>Total Amount:</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right">
                    {NumberFormat(total.Total, 0)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
          <div className="text-end mt-5">
            <Pagination
              current={pageNo}
              pageSize={pageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange} // Handle page size change
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageVouchers;
